import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Avatar, Divider} from "reakit";
import {Box, Flex, Heading, Text} from 'rebass';
import {Container, Content, MobileHeader} from "../../components/Base";
import Parents from "../../components/StudentSummary/Parents";

import {schoolSelectors} from "../../store/school";


class MyProfile extends Component {

	state = {
		parents: []
	};

	componentDidMount() {
		const { isFaculty} = this.props;

		if(!isFaculty){
			this.handleFetchParentInfo()

		}
	}

	handleFetchParentInfo = async () => {
		const {firebase, profile} = this.props;
		let parents = profile.parents;
		if (parents.length > 0) {
			try {
				let result = [];
				let parentRef = firebase.parents();
				for (let i in parents) {
					let doc = await parentRef.doc(parents[i]).get();
					result.push({id: doc.id, ...doc.data()})
				}
				this.setState({parents: result})
			} catch (err) {

			}
		}

	};
	render() {
		const {parents} = this.state;
		const {profile, isFaculty, schoolInfo} = this.props;

		let dorm = ''
		if(schoolInfo && schoolInfo.subDormMap){
			const dormData = schoolInfo.subDormMap[profile.sub_dorm]

			if(dormData){
				dorm = dormData.name
			}
		}
		return (
			<Box p={[0, 4]}>
				<MobileHeader>
					<Heading py={2} >My Profile</Heading>
				</MobileHeader>
				<Content>

					<Container>
						<Flex flexWrap={'wrap'} flexDirection={'row'} px={3} mx={1}>
							<Box>
								<Heading marginTop={'20px'} marginLeft={'5px'} display='inline-block'
								         fontSize={'21px'}>{profile.first_name} {profile.last_name}</Heading>
							</Box>
							<Box ml={'auto'}/>
							<Box>
								<Avatar src={profile && profile.profile_pic} palette={'greys'} opaque tone={0} fontSize={50}/>
							</Box>

						</Flex>
						{isFaculty ?
							<Flex flexWrap={'wrap'} p={1} mt={1} px={3} mx={1}>
								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>School</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>The Hill School</Text></Box>
								</Flex>
								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>Title</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>{profile.position}</Text></Box>
								</Flex>

								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>Email</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>{profile.email}</Text></Box>
								</Flex>

								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								

							</Flex> :
							<Flex flexWrap={'wrap'} p={1} mt={1} px={3} mx={1}>
								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>School</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>The Hill School</Text></Box>
								</Flex>

								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>


								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>Email</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>{profile.email}</Text></Box>
								</Flex>


								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								{!isFaculty &&
								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>Mobile</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>{profile.home_phone}</Text></Box>
								</Flex>
								}

								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>Grade</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>{profile.grade}</Text></Box>
								</Flex>
								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>


								<Flex width={1} py={3}>
									<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'} fontWeight={600}>Dorm</Text></Box>
									<Box ml={'auto'}/>
									<Box><Text color='#969a9b' fontSize={'16px'} fontWeight={600}>{dorm}</Text></Box>
								</Flex>

								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>

								<Box width={1} py={3}>
									<Parents parents={parents} profile={profile}/>

								</Box>

								<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>
							</Flex>
						}

					</Container>
				</Content>
			</Box>
		);
	}
}



const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school)
});


export default connect(mapStateToProps)(MyProfile)
